export const SITE_URL = "https://pycray.com";
export const SITE_NAME = "PyCray Technologies";
export const DEFAULT_OG_IMAGE = `${SITE_URL}/og-image.png`;

export const CAREER_POSITIONS = [
  {
    title: "Full-Stack Developer",
    description: "Develop scalable applications for client projects.",
    location: "Remote",
  },
  {
    title: "QA Engineer",
    description:
      "Ensure quality and performance for services and product releases.",
    location: "Remote",
  },
  {
    title: "Business Analyst",
    description:
      "Collaborate with clients and teams to shape impactful solutions.",
    location: "Remote",
  },
];

export const SEO_PAGES = {
  home: {
    title: "PyCray Technologies — AI That Works on a Solid Foundation",
    description:
      "IIT-IIM founded engineering firm. We fix your data, systems, and application foundation — then build AI that delivers measurable ROI for SMBs.",
    keywords:
      "PyCray, AI implementation, full-stack engineering, SMB AI, data foundation, RAG systems, Pune India",
    path: "/",
  },
  enterprise: {
    title: "Enterprise AI & Engineering Solutions",
    description:
      "Partner with PyCray for enterprise-grade AI implementation, full-stack engineering, and scalable systems built on a solid data foundation.",
    keywords:
      "enterprise AI, AI consulting, full-stack development, enterprise software, PyCray",
    path: "/enterprise",
  },
  useCases: {
    title: "AI Use Cases — Live AI Demos for Real Businesses",
    description:
      "Explore PyCray SiteIQ, TalentBridge, BuddyBot, PyCray Kart, PolicyPal, and FlowIQ — production AI use cases with live demos. Construction progress tracking, hiring, ecommerce support, document Q&A, and invoice automation built on Claude.",
    keywords:
      "AI use cases, SiteIQ, TalentBridge, BuddyBot, PyCray Kart, PolicyPal, FlowIQ, construction progress AI, computer vision site monitoring, CV screening AI, conversational AI, ecommerce support agent, bilingual voice AI, RAG systems, invoice automation, Claude Sonnet, PyCray demos",
    path: "/use-cases",
  },
  about: {
    title: "About Us — IIT-IIM Founded Engineering Team",
    description:
      "Meet the PyCray team. IIT and IIM alumni building AI on solid foundations — fixing data, systems, and applications before deploying AI that delivers ROI.",
    keywords: "PyCray team, IIT IIM founders, AI engineering company, Pune India",
    path: "/about-us",
  },
  careers: {
    title: "Careers — Join PyCray Technologies",
    description:
      "Remote-first roles at PyCray. We're hiring Full-Stack Developers, QA Engineers, and Business Analysts to build production AI systems that matter.",
    keywords:
      "PyCray careers, remote jobs, full-stack developer jobs, QA engineer jobs, AI jobs India",
    path: "/careers",
  },
  forge: {
    title: "PYCRAY Forge — Build Real Things",
    description:
      "A structured 4-month program — training + internship — where you work on real products mentored by IIT & IIM alumni founders. Cohort Q3 · 2026.",
    keywords:
      "PYCRAY Forge, product training, internship, IIT IIM mentors, frontend developer, backend developer, QA engineer, product manager",
    path: "/forge",
  },
  sessions: {
    title: "Career Launchpad Sessions — PyCray Forge",
    description:
      "Free weekly live sessions for engineering students and freshers — practical guidance on tech careers, AI tools, interviews, and the leap from college to corporate IT life.",
    keywords:
      "PyCray Forge sessions, career launchpad, engineering students, tech career, interviews, AI tools, college to corporate, live sessions",
    path: "/sessions",
  },
  terms: {
    title: "Terms & Conditions",
    description:
      "Read the terms and conditions for using PyCray Technologies website and services.",
    path: "/terms-and-conditions",
  },
  privacy: {
    title: "Privacy Policy",
    description:
      "Learn how PyCray Technologies collects, uses, and protects your personal information.",
    path: "/privacy-policy",
  },
  notFound: {
    title: "Page Not Found",
    description: "The page you are looking for does not exist.",
    noindex: true,
  },
};

export function getOrganizationSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: SITE_NAME,
    alternateName: "PyCray",
    url: SITE_URL,
    logo: `${SITE_URL}/logo512.png`,
    description:
      "IIT-IIM founded engineering firm building AI on solid data and systems foundations for SMBs.",
    sameAs: ["https://www.linkedin.com/company/pycray-technologies"],
    contactPoint: {
      "@type": "ContactPoint",
      telephone: "+91-8758379686",
      contactType: "Customer Service",
      areaServed: "IN",
      availableLanguage: "English",
    },
    address: {
      "@type": "PostalAddress",
      addressCountry: "IN",
    },
  };
}

export function getWebSiteSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: SITE_NAME,
    url: SITE_URL,
  };
}

export function getBreadcrumbSchema(items) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((item, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: item.name,
      item: `${SITE_URL}${item.path}`,
    })),
  };
}

export function getJobPostingSchemas() {
  return CAREER_POSITIONS.map((position) => ({
    "@context": "https://schema.org",
    "@type": "JobPosting",
    title: position.title,
    description: position.description,
    hiringOrganization: {
      "@type": "Organization",
      name: SITE_NAME,
      sameAs: SITE_URL,
      logo: `${SITE_URL}/logo512.png`,
    },
    jobLocation: {
      "@type": "Place",
      address: {
        "@type": "PostalAddress",
        addressCountry: "IN",
      },
    },
    jobLocationType: "TELECOMMUTE",
    employmentType: "FULL_TIME",
    url: `${SITE_URL}/careers`,
  }));
}
